"use strict";

var __importDefault = function (e) {
  return e && e.__esModule ? e : {
    default: e
  };
},
    react_1 = (Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PrevNextButton = void 0, __importDefault(require("react"))),
    types_1 = require("../types"),
    utils_1 = require("../utils");

exports.PrevNextButton = function (e) {
  var t = e.name,
      s = e.isDisabled,
      a = e.onClick,
      r = e.renderPrevButton,
      e = e.renderNextButton;
  if ("function" == typeof r) return react_1.default.createElement("div", {
    className: types_1.Classnames.BUTTON_PREV,
    onClick: a
  }, r({
    isDisabled: s
  }));
  if ("function" == typeof e) return react_1.default.createElement("div", {
    className: types_1.Classnames.BUTTON_NEXT,
    onClick: a
  }, e({
    isDisabled: s
  }));
  var r = "prev" === t,
      e = r ? "<" : ">",
      t = r ? types_1.Classnames.BUTTON_PREV : types_1.Classnames.BUTTON_NEXT,
      l = r ? types_1.Classnames.BUTTON_PREV_WRAPPER : types_1.Classnames.BUTTON_NEXT_WRAPPER,
      r = r ? types_1.Classnames.BUTTON_PREV_ITEM : types_1.Classnames.BUTTON_NEXT_ITEM,
      s = s ? types_1.Modifiers.INACTIVE : "",
      r = utils_1.concatClassnames(r, s);
  return react_1.default.createElement("div", {
    className: t
  }, react_1.default.createElement("div", {
    className: l
  }, react_1.default.createElement("p", {
    className: r,
    onClick: a
  }, react_1.default.createElement("span", {
    "data-area": e
  }))));
};